import React from 'react';
import { number } from '../../../Common/Util/number';
import { useSchedulingChartsDataContext } from './hooks/useSchedulingChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const TableScheduling = () => {
    const { chartData } = useSchedulingChartsDataContext();

    const columns = [
        {
            key: 'description',
            header: 'Unidade de Saúde',
            headerStyle: {
                width: '20%',
                fontWeight: '500'
            },
            cellStyle: {
                fontWeight: '500'
            }
        },
        {
            key: 'schedules',
            header: 'Agendamentos',
            headerStyle: {
                width: '15%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right',
                fontFamily: 'monospace'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'serviceBalance',
            header: 'Saldo de Atendimentos',
            headerStyle: {
                width: '15%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right',
                fontFamily: 'monospace'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'attendancePercentage',
            header: '% de Atendimentos',
            headerStyle: {
                width: '15%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) =>
                isNaN(value) ? '-' : number.formatToPercentage(value)
        },
        {
            key: 'serviceBalancePercentage',
            header: '% do Saldo de Atendimentos',
            headerStyle: {
                width: '15%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) =>
                isNaN(value) ? '-' : number.formatToPercentage(value)
        },
        {
            key: 'absenteeism',
            header: 'Absenteísmo',
            headerStyle: {
                width: '10%',
                textAlign: 'right'
            },
            cellStyle: {
                textAlign: 'right',
                fontFamily: 'monospace'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'absenteeismPercentage',
            header: '% de Absenteísmo',
            headerStyle: {
                width: '10%',
                textAlign: 'right'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) =>
                isNaN(value) ? '-' : number.formatToPercentage(value)
        }
    ];

    const calculateTotals = (data) => {
        if (!data || !Array.isArray(data)) return null;

        return {
            description: 'Total',
            schedules: data.reduce(
                (acc, curr) => acc + Number(curr.schedules || 0),
                0
            ),
            serviceBalance: data.reduce(
                (acc, curr) => acc + Number(curr.serviceBalance || 0),
                0
            ),
            attendancePercentage: '-',
            serviceBalancePercentage: '-',
            absenteeism: data.reduce(
                (acc, curr) => acc + Number(curr.absenteeism || 0),
                0
            ),
            absenteeismPercentage: '-'
        };
    };

    const tableData = React.useMemo(() => {
        if (!chartData?.tableSceduling) return [];

        const data = [...chartData.tableSceduling];
        const totals = calculateTotals(chartData.tableSceduling);

        if (totals) {
            data.push(totals);
        }

        return data;
    }, [chartData?.tableSceduling]);

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                className="w-100"
                data={tableData}
                columns={columns}
                title="Totais"
                showTotal={false}
                maxHeight="500px"
                isLastTotal
            />
        </div>
    );
};
